/** @format */
import { AlarmReciverObject } from 'src/utils/interface'
import { InstanceItem } from 'src/components/SelectInstance/constants'
// 详情-抽屉props
export interface DetailDrawerProps {
  className?: string
  visible: boolean
  setVisible: (value: boolean) => void
  data: any
}

// 创建告警-抽屉props
export interface CreateAlarmDrawerProps {
  className?: string
  visible: boolean
  setVisible: (value: boolean) => void
  submitCallback?: (value: CreateFormValuesProps) => void
  defaultValues?: CreateFormValuesProps
  eventList?: any[]
}

// 创建告警-抽屉-formValue
export interface CreateFormValuesProps {
  PolicyName?: string
  PolicyDesc?: string
  ProductType?: string
  TemplateID?: number
  ResourceBindType?: number
  InstanceGrpIds?: string[]
  InstanceIds?: InstanceItem[]
  ProjectId?: number
  EventRadio?: number
  EventNames?: string[]
  UserNotice?: AlarmReciverObject[]
  UrlNotice?: string[]
}

// 创建告警-抽屉-initValue
export const createFormValueInit: CreateFormValuesProps = {
  PolicyName: '',
  PolicyDesc: '',
  ProductType: undefined,
  ResourceBindType: 3,
  InstanceGrpIds: [],
  InstanceIds: [],
  ProjectId: null,
  EventRadio: 1,
  EventNames: ['*'],
  UserNotice: [],
  UrlNotice: []
}

// 选择事件抽屉Props
export interface EventDialogProps {
  className?: string
  productType: string
  eventList?: any[]
  defaultRadio?: number
  defaultValue?: string[]
  onChange?: (radio: number, eventNames: any[]) => void
}
